import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Clip, ProjectExplorer, Navigator, FilePropertiesWrapper, FileTabs } from "../helpers/devMode";
import { useAuthContext } from "../contexts/Auth";
import "./DevMode.css";
import { devActions } from "../../redux/actions";
import { DevModeContext, defaultGridItemsState } from "./DevMode.helpers";
import { Responsive, WidthProvider } from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import * as immutable from 'object-path-immutable'
import { RiDraggable } from "react-icons/ri";
import { RiCloseFill } from "react-icons/ri";
import { emptyObject } from "../../redux/utils";
import { useFeatureAccessContext } from "../contexts/FeaturesAccess";
import { ElementLibrary } from "../helpers/devMode/ElementLibrary";

const ResponsiveGridLayout = WidthProvider(Responsive);

export const DevMode = ({}) => {
  const { config, menu, loaded, load } = useFeatureAccessContext();
  const dispatch = useDispatch();
  const selectedTab = useSelector(state => state.dev.selectedTab);
  const tabs = useSelector(state => state.dev.tabs);
  const openTab = useMemo(() => {
    return tabs[selectedTab];
  }, [selectedTab, tabs]);
  const { reLogin } = useAuthContext();
  
  const [ gridItems, setGridItems ] = useState(getSavedGridItems);
  const [ currentBreakpoint, setCurrentBreakpoint ] = useState("lg");

  useEffect(()=>{
    console.log("DevMode", {config, menu, loaded})
  }, [config, menu, loaded]);



  //se renueva el token cada 8 horas
  useEffect(()=>{
    const intervalId = setInterval(()=>{ reLogin() }, 1000 * 60 * 60 * 8);
    changeBodyStyle();
    return ()=>{
      clearInterval(intervalId)
      restoreBodyStyle();
    } 
  }, [])
  
  const handleResize = (event, data) => {
    dispatch(devActions.setExplorerWidth(data.size.width));
  }
  
  const handleOnSaved = useCallback(() => {
    return dispatch(devActions.setChangedTab(selectedTab, false));
  }, [selectedTab])

  const [applyChangeTimer, setApplyChangeTimer] = useState(0);

  
  const saveChangeLayout = (data) => {
    
      clearTimeout(applyChangeTimer);

      const index =  gridItems[currentBreakpoint].findIndex(item => item.key === data.i);
      const newGridItems = immutable.set(gridItems, `${currentBreakpoint}.${index}.dataGrid`, data);
      console.log("breakpoint change effect", {data, gridItems, index, newGridItems, currentBreakpoint});
      
      setGridItems(newGridItems);
      
      setApplyChangeTimer(
        setTimeout(() => {      
        }, 150)
      )  

  }

  const handleDragStop = (layout, prevData, currentData) => {
    console.log("handleDragStop event", {currentBreakpoint, layout, prevData, currentData});
    saveChangeLayout(currentData);
  }

  const handleOnResizeStop = (layout, prevData, currentData) => {
    console.log("handleOnResizeStop event", {currentBreakpoint, layout, prevData, currentData});
    saveChangeLayout(currentData);
  }

  const handleLayoutChange = (layout, allLayouts) => {
    //localStorage.setItem("dev-layouts", JSON.stringify(allLayouts));
    //setLayout(allLayouts);
    /*const newGridItems = Object.keys(allLayouts).reduce((gridItems, key) => {
      return {
        ...gridItems,
        [key]: gridItems[key].map(item => ({...item, dataGrid: allLayouts[key].find(data => data.i === item.key)}))
      }
    }, gridItems);*/
    console.log("change layout", {layout});
  }

  useEffect(()=>{
    localStorage.setItem("dev-grid-items", JSON.stringify(gridItems));
  }, [gridItems]);

  const layout = useMemo(()=>{
    const newLayout = Object.keys(gridItems).reduce((newLayout, key)=>{
      if(gridItems[key].some(item => item.dataGrid)){
        return {
          ...newLayout,
          [key]: gridItems[key].filter(item => item.dataGrid && item.show).map(item => item.dataGrid)
        }
      }else{
        return newLayout;
      }
    }, {}); 
    return newLayout;
    //console.log("gridItems change create new layout", {newLayout, gridItems})
    //setLayout(newLayout);
  }, [gridItems]);

/*    allLayouts[currentBreakpoint].forEach((data, index) => {  
      setGridItems(gridItems => {

        updateDataGrid(gridItems, gridItems[currentBreakpoint].findIndex(item => item.key === data.i), currentBreakpoint, false, data)

      });
    });*/

  const handleBreakpointChange = (breakpoint) => {
    console.log("change breakpoint event", {breakpoint, layout, gridItems})
    setCurrentBreakpoint(breakpoint);
  }

  const updateDataGrid = useCallback((gridItems, index, breakpoint, show) => {
    return immutable.set(gridItems, `${breakpoint}.${index}.show`, show);
  }, []);

  const handlePanelHide = useCallback((breakpoint, index) => {
    setGridItems(dataGrid => updateDataGrid(dataGrid, index, breakpoint, false));
  }, [updateDataGrid]);

  const handlePanelShow = useCallback((breakpoint, index) => {
    setGridItems(dataGrid => updateDataGrid(dataGrid, index, breakpoint, true));
  }, [updateDataGrid]);

  const contents = useMemo(()=>{
    return Object.keys(panelContents).reduce((prev, key) => {
      const Content = panelContents[key];
      return {...prev, [key]: <Content />};
    }, emptyObject);
  }, []);

  const gridItemsMemo = useMemo(()=>{
    const newGridItemsMemo = gridItems[currentBreakpoint]
      .map((item, index) =>{
        if(!item.show) return;
        return gridItem({...item, dataGrid: item.dataGrid || defaultDataGridValue(item.key), content: contents[item.content], onHide: ()=>{handlePanelHide(currentBreakpoint, index)}})
      });
    //console.log("gridItemsMemo", {gridItems, currentBreakpoint, handlePanelHide, layout, newGridItemsMemo})
    return newGridItemsMemo;
  }, [gridItems, currentBreakpoint, handlePanelHide]);

  const clipsCounts = useMemo(()=>{
    return gridItems[currentBreakpoint].filter(item => !item.show).length;
  }, [gridItems, currentBreakpoint]);

  const clips = useMemo(()=>{
    return gridItems[currentBreakpoint].map((item, index) => {
      if(item.show) return;
      return <div key={item.title} style={{padding: 4, border: "#585757 solid 1px", height: 30, cursor: "pointer"}} onClick={() => handlePanelShow(currentBreakpoint, index)}>{item.title}</div>
    })
  }, [handlePanelShow, currentBreakpoint, gridItems]);

  return (
    <>
      {loaded && clipsCounts > 0 &&    
        <Clip>
          <div style={{width: 100, maxWidth: 100, overflowX: "hidden", color: "white", backgroundColor: "#4b4b4b"}}>
            {clips}
          </div>
        </Clip>
      }
      {loaded && 
      
        <DevModeContext.Provider value={{ openTab, onSaved: handleOnSaved, selectedTab }} >
          <ResponsiveGridLayout
            className="layout dev-root"
            breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
            cols={{ lg: 24, md: 20, sm: 12, xs: 8, xxs: 4 }}
            draggableHandle=".dev-handler"
            resizeHandles={['s','e','w','se']}
            margin={[0, 0]}
            containerPadding={[15, 5]}
            rowHeight={32}
            onLayoutChange={handleLayoutChange}
            onDragStop={handleDragStop}
            onResizeStop={handleOnResizeStop}
            onBreakpointChange={handleBreakpointChange}
            preventCollision={true}
            verticalCompact={false}

          >
            {gridItemsMemo}
          </ResponsiveGridLayout>
        </DevModeContext.Provider>
      }
    </>
  );
}
const restoreBodyStyle = () => {
    var body = document.body;
    body.style.paddingTop = '50px';
    body.style.paddingBottom = '20px';
    body.style.backgroundColor = 'rgb(238, 240, 248)'; 
}

const changeBodyStyle = () => {
  var body = document.body;
  body.style.paddingTop = '0px';
  body.style.paddingBottom = '0px';
  body.style.backgroundColor = '#2a2b27'; 
}


const getSavedGridItems = () => {
  const data = localStorage.getItem("dev-grid-items");
  if(!!data){
    try{
      return JSON.parse(data);
    }catch(e){
      return defaultGridItemsState;
    }
  }else{
    return defaultGridItemsState;
  }
}

const panelContents = { ProjectExplorer, Navigator, FilePropertiesWrapper, FileTabs, ElementLibrary };


const gridItem = ({key, title, content, scrollable, onHide, canClose, dataGrid = emptyObject}) => {
  //console.log("gridItem", {key, title, content, scrollable, onHide, dataGrid});
  const handleGoToEditMode = () => {
    window.location.href = "/consola";
  };

  return (
    <div key={key} data-grid={{...dataGrid, minW: 3, minH: 4}}>
      <div className="dev-panel">
        <div className="dev-header">
          <div className="dev-handler"><RiDraggable /></div>
          <div className="dev-title">{title}</div>
          {key === "explorer" &&
            <button type="button" className="dev-edit-mode-btn" onClick={handleGoToEditMode}>
              Modo edición
            </button>
          }
          {canClose &&
            <div onClick={onHide} style={{cursor: "pointer"}}><RiCloseFill/></div>
          }
        </div>
        <div className={`dev-content ${scrollable ? 'scrollable' : ''}`}>
          {content}
        </div>
      </div>
    </div>    
  );
}

const defaultDataGridValue = (i) => ({
  "w": 4,
  "h": 4,
  "x": 0,
  "y": 0,
  i,
  "moved": false,
  "static": false
})
